<span class="loader" *ngIf="(isLoaded$ | async) === false"></span>

<div #pages class="container" dir="ltr"></div>
